import React, { useEffect, useState } from 'react';
import '../styles/topcontainer.css';
import { Link } from 'react-router-dom';

const TopContainer = () => {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    try {
      const itemStr = localStorage.getItem('isLogin');
      const parsed = itemStr ? JSON.parse(itemStr) : null;
      if (parsed && parsed.expiry && parsed.expiry > Date.now()) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    } catch {
      setIsLogin(false);
    }
  }, []);

  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Master Your Exams with <br />Comprehensive Practice</h1>
        <p>
          Realistic exam simulations with detailed performance analysis to help you succeed.
        </p>
        <div className="hero-buttons">
          <Link to="/all-exam-prep-practice-test">     
          <button className="btn-primary-tc">Browse All Exams</button>
          </Link>
          {!isLogin && (
            <Link to="/register">
              <button className="btn-secondary-tc">Get Started</button>
            </Link>
          )}
        </div>

        <div className="stats-container-home">
          <div className="stat-card-home">
            <h2>30+</h2>
            <p>Certification Exams</p>
          </div>
          <div className="stat-card-home">
            <h2>100K+</h2>
            <p>Practice Questions</p>
          </div>
          <div className="stat-card-home">
            <h2>95%</h2>
            <p>Pass Rate</p>
          </div>
          <div className="stat-card-home">
            <h2>10K+</h2>
            <p>Happy Students</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopContainer;
